module.exports = __webpack_public_path__ + "static/media/2018_conf_User_Value_Creation.90ffbf27.png";